import { Link } from 'react-router-dom';

export default function CallToAction() {
  return (
    <section className="py-20 bg-gradient-to-br from-green-700 to-green-800 relative overflow-hidden">
      {/* Subtle background texture */}
      <div
        className="absolute inset-0 opacity-10 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/b51cd490018eb1a499bedbd19f5e4efd.jpg)',
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center bg-white/15 text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest mb-4">
            <i className="ri-map-pin-line mr-2"></i>Proudly Grown & Processed in Ghana
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Ready to Experience<br />the Best of Ghana's Farms?
          </h2>
          <p className="text-xl text-green-100 mb-10 max-w-3xl mx-auto">
            Whether you are here for our sustainable BSF protein products, expert farming training, or our pure moringa powder superfood — we have something powerful for you.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <a
            href="https://paystack.shop/pay/v9-4hu3n50"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center text-center bg-amber-500 hover:bg-amber-400 text-white px-6 py-5 rounded-xl font-semibold transition-colors cursor-pointer"
          >
            <i className="ri-shopping-bag-line text-2xl mb-2"></i>
            <span className="text-base whitespace-nowrap">Order Moringa Powder</span>
            <span className="text-xs text-amber-100 mt-1">Pure · Natural · Ghanaian</span>
          </a>
          <Link
            to="/products"
            className="flex flex-col items-center text-center bg-white hover:bg-gray-100 text-green-700 px-6 py-5 rounded-xl font-semibold transition-colors cursor-pointer"
          >
            <i className="ri-store-2-line text-2xl mb-2"></i>
            <span className="text-base whitespace-nowrap">Explore All Products</span>
            <span className="text-xs text-green-500 mt-1">BSF · Fertilizer · Moringa</span>
          </Link>
          <Link
            to="/contact"
            className="flex flex-col items-center text-center bg-white/15 hover:bg-white/25 border border-white/30 text-white px-6 py-5 rounded-xl font-semibold transition-colors cursor-pointer"
          >
            <i className="ri-graduation-cap-line text-2xl mb-2"></i>
            <span className="text-base whitespace-nowrap">Join a Training</span>
            <span className="text-xs text-green-200 mt-1">BSF Farming · Consultancy</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
